import { FunctionComponent, PropsWithChildren, useState } from "react";
import { UseMutationResult } from "react-query";
import { CommandRunnerContext } from "./command-runner-context";

export const CommandRunnerContextProvider: FunctionComponent<PropsWithChildren> = props => {
  const [isBusy, setIsBusy] = useState<boolean>(false);
  const [commandName, setCommandName] = useState<string>("");
  const [status, setStatus] = useState<string>("");

  const runMutation = <TArgs,>(
    commandName: string,
    mutation: UseMutationResult<string, Error, TArgs>,
    args: TArgs
  ) => {
    setIsBusy(true);
    setCommandName(commandName);
    setStatus("Running");

    mutation.mutate(args, {
      onSettled: (result: string, error: Error) => {
        setStatus(
          error?.message ? `Error - ${error.message}` : result ?? "No result"
        );

        setIsBusy(false);
      }
    });
  };

  return (
    <CommandRunnerContext.Provider
      value={{ isBusy, status, commandName, runMutation }}
      {...props}
    />
  );
};
